// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apps-wrapper__container{display:flex;flex-direction:column;position:relative;width:100%;flex-wrap:wrap;flex-grow:1;min-width:0}.apps-wrapper__container--darken::after{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.5);cursor:pointer;z-index:101}", ""]);
// Exports
module.exports = exports;
